module.exports = __webpack_public_path__ + "static/media/idCard.c9b4663f.png";